export default __webpack_public_path__ + "static/media/gamification-img-sm-unused.c2c59cea.png";